<template>
	<v-form ref="formActual">
		<v-container grid-list-md>
			<v-layout row wrap>
				<v-flex xs12 md3>
					Peso actual:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[!!valor.PesoActual || 'Campo Obligatorio']"
						v-model="valor.PesoActual"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					¿Se encuentra en diálisis?
				</v-flex>
				<v-flex xs12 md3>
					<v-radio-group
						v-model="valor.EnDialisis"
						hide-details="auto"
						row
						mandatory
						class="ma-0 pa-0 pr-4 pt-1"
					>
						<v-radio label="Sí" :value="true"></v-radio>
						<v-radio label="No" :value="false"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs12 md3>
					Peso prediálisis:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[
							!valor.EnDialisis ||
								!!valor.PesoPredialisis ||
								'Campo Obligatorio'
						]"
						v-model="valor.PesoPredialisis"
						type="number"
						:disabled="!valor.EnDialisis"
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Peso postdiálisis:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[
							!valor.EnDialisis ||
								!!valor.PesoPostdialisis ||
								'Campo Obligatorio'
						]"
						v-model="valor.PesoPostdialisis"
						type="number"
						:disabled="!valor.EnDialisis"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Peso seco:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[!!valor.PesoSeco || 'Campo Obligatorio']"
						v-model="valor.PesoSeco"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Talla:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[!!valor.TallaM || 'Campo Obligatorio']"
						v-model="valor.TallaM"
						type="number"
						suffix="m"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Talla:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						suffix="cm"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.TallaCm"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					IMC:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						suffix="kg/m2"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.Imc"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Interpretación IMC:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.InterpretacionImc"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Peso habitual
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[!!valor.PesoHabitual || 'Campo Obligatorio']"
						v-model="valor.PesoHabitual"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					% Peso Habitual:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						suffix="%"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.PorcentajePesoHabitual"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Interpretación % de peso habitual:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.InterpretacionPesoHabitual"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					% pérdida de peso:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						suffix="%"
						:value="valor.PorcentajePerdidaPeso"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Interpretación % de pérdida de peso:
				</v-flex>
				<v-flex xs12 md3>
					<v-autocomplete
						:rules="[
							!!valor.InterpretacionPerdidaPeso ||
								'Campo Obligatorio'
						]"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						v-model="valor.InterpretacionPerdidaPeso"
						:items="catalogos.InterpretacionesPerdidaPeso"
						return-object
						item-text="Descripcion"
					></v-autocomplete>
				</v-flex>
				<v-flex xs12 md3>
					Peso ideal o recomendado:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[!!valor.PesoIdeal || 'Campo Obligatorio']"
						v-model="valor.PesoIdeal"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					% peso ideal:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						suffix="%"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.PorcentajePesoIdeal"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Interpretación % de peso ideal:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.InterpretacionPesoIdeal"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Peso ajustado libre de edema:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						suffix="kg"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.PesoAustadoLibreEdema"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Circunferencia de cintura :
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[
							!!valor.CircunferenciaCintura || 'Campo Obligatorio'
						]"
						v-model="valor.CircunferenciaCintura"
						type="number"
						suffix="cm"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Circunferencia de cadera:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						:rules="[
							!!valor.CircunferenciaCadera || 'Campo Obligatorio'
						]"
						v-model="valor.CircunferenciaCadera"
						type="number"
						suffix="cm"
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md3>
					Índice Cintura-Cadera:
				</v-flex>
				<v-flex xs12 md3>
					<v-text-field
						hide-details="auto"
						class="ma-0 pa-0 pr-4 pt-1"
						solo
						readonly
						:value="valor.IndiceCinturaCadera"
					></v-text-field>
				</v-flex>
				<v-flex xs12 md4> </v-flex>
				<v-flex xs12 md3>
					Amputaciones
				</v-flex>
				<v-flex xs12 md3>
					<v-radio-group
						hide-details="auto"
						row
						mandatory
						v-model="valor.Amputaciones"
						class="ma-0 pa-0 pr-4 pt-1"
					>
						<v-radio label="Sí" :value="true"></v-radio>
						<v-radio label="No" :value="false"></v-radio>
					</v-radio-group>
				</v-flex>
				<template v-if="valor.Amputaciones">
					<v-flex xs12 md3>
						%/Kg de amputación:
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field
							:rules="[
								!!valor.CantidadAmputacion ||
									'Campo Obligatorio'
							]"
							v-model="valor.CantidadAmputacion"
							type="number"
							hide-details="auto"
							class="ma-0 pa-0 pr-4 pt-1"
						></v-text-field>
					</v-flex>
				</template>
			</v-layout>
			<v-layout row class="mt-3">
				<v-flex xs6>
					<v-btn color="primary" @click.prevent="anterior">
						<v-icon>arrow_back_ios</v-icon> ANTERIOR
					</v-btn>
				</v-flex>
				<v-flex xs6 class="text-right">
					<v-btn color="primary" @click.prevent="guardar">
						<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
					</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos"],
	name: "evaluacionAntropometrica",
	data() {
		return {
			valor: {},
			catalogos: {
				InterpretacionesPerdidaPeso: []
			}
		};
	},
	methods: {
		obtenerCatalogos() {
			this.catalogos.InterpretacionesPerdidaPeso = this.$root.generarCatalogo(
				["Sin Pérdida", "Pérdida Significativa", "Pérdida Grave"]
			);
		},
		getRandom() {
			return Math.floor(Math.random() * 100);
		},
		siguiente() {
			this.$emit("siguiente", this.valor);
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarEvaluacionAntropometrica(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		actualizarFormulas() {
			this.valor.Imc = this.$root.formulas.indiceMasaCorporal(
				this.valor.PesoSeco,
				this.valor.TallaM
			);
			if (this.valor.TallaM) {
				this.valor.TallaCm = this.valor.TallaM * 100;
			}
			this.valor.InterpretacionImc = this.$root.formulas.interpretacionIMC(
				this.valor.Imc
			);
			this.valor.PorcentajePesoHabitual = this.$root.formulas.ptgPesoHabitual(
				this.valor.PesoSeco,
				this.valor.PesoHabitual
			);
			this.valor.InterpretacionPesoHabitual = this.$root.formulas.interpretacionPesoHabitual(
				this.valor.PorcentajePesoHabitual
			);
			this.valor.PorcentajePerdidaPeso = this.$root.formulas.ptgPerdidaPeso(
				this.valor.PesoHabitual,
				this.valor.PesoSeco,
				this.valor.PorcentajePesoHabitual
			);
			this.valor.PorcentajePesoIdeal = this.$root.formulas.ptgPesoIdeal(
				this.valor.PesoSeco,
				this.valor.PesoIdeal
			);
			this.valor.InterpretacionPesoIdeal = this.$root.formulas.interpretacionPesoIdeal(
				this.valor.PorcentajePesoIdeal
			);
			this.valor.PesoAustadoLibreEdema = this.$root.formulas.pesoAjustadoLibreEdema(
				this.valor.PesoSeco,
				this.valor.PesoIdeal
			);
			this.valor.IndiceCinturaCadera = this.$root.formulas.indiceCinturaCadera(
				this.valor.CircunferenciaCintura,
				this.valor.CircunferenciaCadera
			);
		}
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	mounted() {
		this.obtenerCatalogos();
	},
	watch: {
		valor: {
			deep: true,
			handler() {
				this.actualizarFormulas();
			}
		},

		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	}
};
</script>

<style></style>
